import { createContext } from 'react';
/**
 * Throw error when HeaderContextType is used outside of context provider
 */
const invariantViolation = () => {
    throw new Error('Attempted to call useHeader outside of header context. Make sure your app is rendered inside HeaderProvider.');
};
export const emptyHeaderContext = {
    isHeaderShown: false,
    isMenuButtonShown: true,
    searchBar: null,
    headerItems: null,
    secondRowItems: null,
    headerHeight: 0,
    defaults: {},
};
/**
 * Header Context Object
 */
export const HeaderContext = createContext([emptyHeaderContext, invariantViolation]);
//# sourceMappingURL=HeaderContext.js.map